import { ApiService } from './apiService'
import { baseApiUrl } from '../config'
import { CompanyInsights, GraphData, InsightsFilters, MaintenanceMode } from '../types/GraphData'
import { SegmentDto } from '../types'

const audienceServiceUrl = '/api/v3/estimation'

export class InsightsService extends ApiService {
    async filterInsights(filters: InsightsFilters): Promise<GraphData | null> {
        let _filters = filters

        if (!filters.filters) {
            // hot fix for the BE side (it does not support undefined filters property)
            _filters = { ...filters, filters: {} }
        }
        return this.post(`${audienceServiceUrl}/estimate`, _filters)
    }

    async getSnapshot(filters: InsightsFilters): Promise<CompanyInsights | null> {
        return this.post(`${audienceServiceUrl}/static_data`, filters)
    }

    async checkMaintenanceMode(): Promise<MaintenanceMode> {
        return this.get(`${audienceServiceUrl}/maintenance`, null)
    }

    async getDirectLookalikeCategories(categoryIds: number[], companyId?: number): Promise<Record<string, number>> {
        return this.post(`${audienceServiceUrl}/get_lookalike_cats`, { category: categoryIds, companyId })
    }

    async getLookalikeTopics(topicIds: number[], companyId?: number): Promise<Record<number, number>> {
        return this.post(`${audienceServiceUrl}/get_adjacent_topics`, { topics: topicIds, companyId })
    }

    async estimateClickHouse(segment: SegmentDto): Promise<{ size: number; singleSite: number }> {
        return this.post(`${audienceServiceUrl}/audience_builder_estimation`, { ...segment })
    }
}

export const insightsService = new InsightsService(baseApiUrl)
